import React from 'react';
import { InputNumber } from 'antd';

const FieldNumber = ({value, onChange, style = {}, disabled, placeholder}) => {
    return <InputNumber controls={false} style={{ ...style, width: '100%' }} value={value} onChange={onChange} disabled={disabled} placeholder={placeholder} />
}

export default FieldNumber;